export default "__VITE_PUBLIC_ASSET__5205341d__"